export const THEMES = {
    novaporta: 'NOVAPORTA',
    ecaterix: 'ECATERIX',
    foundation: 'FOUNDATION',
    farmacie: 'FARMACIE',
    ecom: 'ECOM'
};
